export async function getExperiments(essentials) {
    const experiments = essentials.createExperiments({
        scopes: ['blocks-widget-services'],
    });
    await experiments.ready();
    return experiments;
}
//# sourceMappingURL=getExperiments.js.map